module.exports = __webpack_public_path__ + "img/removeMessage.6375717a.svg";